<template>
  <CardContainer :cardTitle="title" :isEmptyData="isLoaded && dataSource != null && dataSource.dataset.length === 0" :titleId="'vertical-chart-' + index" :participantName="dataParticipantName" :primaryColor="primaryColor" :choosenAnswers="choosenAnswers">
    <b-row slot="body">
      <!-- <fusioncharts
        type="scrollColumn2d"
        width="100%"
        height="350"
        dataFormat="json"
        :dataSource="dataSource"
      >
      </fusioncharts> -->
      <b-colxx md="10" class="p-0">
        <fusioncharts type="scrollColumn2d" width="100%" height="350" dataFormat="json" :dataSource="dataSource"> </fusioncharts>
      </b-colxx>
      <ChartLegend :participantName="dataParticipantName" :primaryColor="primaryColor"></ChartLegend>
    </b-row>
  </CardContainer>
</template>
<script>
import _ from "lodash";
import CardContainer from "./card-container";
import { generateVerticalBarChartCard, shadeColor } from "../../services/utils";
import { optionsVerticalBarChart } from "../../services/chart-config";
import ChartLegend from "./chart-legend-card";

export default {
  props: {
    index: [String, Number],
    title: { type: String, default: "Default Title" },
    isLoaded: { type: Boolean, default: false },
    dataSources: [Array, null],
    primaryColor: { type: String, default: "" },
    dataParticipantName: { type: String, default: "" }
  },
  components: {
    CardContainer,
    ChartLegend
  },
  data() {
    return {
      dataSource: null,
      colorLegendOthers: shadeColor(this.primaryColor, 30),
      choosenAnswers: []
    };
  },
  methods: {
    processVisualization() {
      const clonedOptions = _.cloneDeep(optionsVerticalBarChart);
      const { categories, datasets, choosenAnswers } = generateVerticalBarChartCard(this.dataSources, this.primaryColor, this.dataParticipantName);
      this.choosenAnswers = choosenAnswers;
      clonedOptions.categories.push({ category: categories });
      clonedOptions.dataset = [...datasets];

      this.dataSource = clonedOptions;
    }
  },
  mounted() {
    this.processVisualization();
  }
};
</script>
